import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { supplierAssetsBasePath } from '@app/telecom/constants/telecom.constants';
import { TelecomSandbox } from '@app/telecom/sandboxes/telecom.sandbox';
import { FormControlGroups, FormControlNames, TelecomInterest, TelecomStep } from '@app/tots/tots-wizard.constants';
import { TotsWizardService } from '@app/tots/tots-wizard.service';
import { WizardService } from '@app/ui/wizard/wizard.service';
import { Move } from '@app/move/interfaces/move';
import { SelectInput } from '@smooved/ui';
import { telecomInterestOptions } from './telecom-interest.constants';

@Component({
    selector: 'app-telecom-interest',
    templateUrl: 'telecom-interest.container.html',
})
export class TelecomInterestContainer implements OnInit {
    public controlNames = FormControlNames;
    public telecomInterestOptions: SelectInput<TelecomInterest>[] = telecomInterestOptions;
    public form: UntypedFormGroup;
    public providers = this.telecomSandbox.providers;
    public supplierAssets = supplierAssetsBasePath;

    constructor(
        private readonly wizardService: WizardService,
        private readonly telecomSandbox: TelecomSandbox,
        private readonly moveSandbox: MoveSandbox
    ) {}

    public ngOnInit(): void {
        this.form = this.wizardService.form.get(FormControlGroups.StepInterest) as UntypedFormGroup;
        this.wizardService.setCurrentStep(TelecomStep.Interest);
    }

    public onNext(): void {
        if (this.form.invalid) return;
        this.moveSandbox.moveOnce$.subscribe((move) => {
            const { interest } = this.form.getRawValue();
            const payload: Partial<Move> = {
                interested: {
                    telecom: [TelecomInterest.Interested, TelecomInterest.Unknown].includes(interest),
                },
                createdByFlow: {
                    tots: [TelecomInterest.Interested].includes(interest),
                },
            };

            if (interest === TelecomInterest.Interested) {
                this.moveSandbox.patchProperty('', payload, false, () => this.wizardService.goToNext());
            } else {
                this.moveSandbox.patchMove(move._id, payload, true, null, (move) => {
                    (this.wizardService as TotsWizardService).onSubmitWizard(move);
                    this.wizardService.reset();
                });
            }
        });
    }
}
